import React from "react";

export default () => {
  return (
    <div className="footer">
        <a href="mailto:snguyenatx@gmail.com" target="_blank" rel="noopener noreferrer"><i className="far fa-envelope"></i></a>
        <a href="https://www.instagram.com/pocketpossum_/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
        <a href="https://www.linkedin.com/in/serenanguyenatx/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
    </div>
  )
}